import { ImagesFormData } from 'src/Libs/installation-statement/models/images'

export const getDefaultImageData = (deviceLinkId: number, installationId: number): ImagesFormData => ({
  deviceLinkId,
  installationId,
  images: {
    complete: { required: true },
    batteries: { required: true },
    connection: { required: true },
    'power-inverter': { required: false },
    'battery-box': { required: false },
  },
})
